module.exports = __webpack_public_path__ + "img/logo_kla.0f9b0e66.svg";